
export default function HeroSection() {
  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-white overflow-hidden"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20surgical%20robot%20in%20pristine%20white%20operating%20room%20with%20teal%20surgical%20lighting%2C%20advanced%20medical%20technology%2C%20clean%20minimalist%20environment%2C%20professional%20medical%20equipment%2C%20sterile%20atmosphere%2C%20high-tech%20precision%20instruments%2C%20futuristic%20healthcare%20setting%2C%20white%20and%20teal%20color%20scheme&width=1920&height=1080&seq=hero-surgery-robot&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-white/80"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Urólogo en<span className="block" style={{ color: '#168B98' }}>Guadalajara</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Dr. Eduardo Cabeza Bucio, especialista en cirugía Urológica. Tratamientos mínimamente invasivos para próstata, riñones, disfunción eréctil y VPH.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://api.whatsapp.com/send/?phone=+523317097105&text=Hola+Dr.+Eduardo+Cabeza+Bucio%2C+me+gustar%C3%ADa+agendar+una+consulta&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white px-8 py-4 rounded-xl text-lg font-semibold hover:opacity-90 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#168B98' }}
              >
                <i className="ri-calendar-line mr-2"></i>
                Agenda tu Consulta
              </a>
              <a 
                href="#tratamientos" 
                className="border-2 px-8 py-4 rounded-xl text-lg font-semibold hover:text-white transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                style={{
                  borderColor: '#168B98', 
                  color: '#168B98'
                }}
                onMouseEnter={(e) => (e.target as HTMLElement).style.backgroundColor = '#168B98'}
                onMouseLeave={(e) => (e.target as HTMLElement).style.backgroundColor = 'transparent'}
              >
                Ver Tratamientos
              </a>
            </div>
            
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: '#168B98' }}>10+ años</div>
                <div className="text-sm text-gray-600">De Experiencia</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: '#168B98' }}>1000+</div>
                <div className="text-sm text-gray-600">Cirugías Exitosas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: '#168B98' }}>100%</div>
                <div className="text-sm text-gray-600">Satisfacción</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 rounded-3xl transform rotate-3 opacity-20" style={{ background: 'linear-gradient(to right, #168B98, #1DB5A3)' }}></div>
            <img 
              src="https://pixel-p3.s3.us-east-1.amazonaws.com/doctor/avatar/6ed7ca73/6ed7ca73-a99d-42f2-a9c1-04c240d48134_large.jpg"
              alt="Sistema Robótico da Vinci"
              className="relative w-full h-96 object-cover object-top rounded-3xl shadow-2xl"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl" style={{ color: '#168B98' }}></i>
      </div>
    </section>
  );
}
